/*
 * Copyright © 2018, Rezo Zero
 *
 * @file ASoundObject.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import AObject from '../abstracts/AObject'
import Point from './Point'
import * as Utils from '../utils/Utils'

export default class ASoundObject extends AObject {
    constructor (url) {
        super()

        this.sound = null
        this.soundUrl = url
        this.peaks = []
        this.points = []
        this.precision = 500 // Length of peaks array
        this.waveWidth = 100 // In pixels
        this.waveSpeed = 6 // Wave Speed (coef of the wave height)
        this.duration = 1 // In seconds
        this.volume = 1
        this.isPlaying = false
        this.isJumping = false
        this.timeout = null
        this.delay = 500
    }

    preload (p5) {
        this.sound = p5.loadSound(window.TEMP.baseurl + this.soundUrl)
    }

    setup (p5) {
        // Get sound duration
        this.duration = p5.round(this.sound.duration() * 1000) / 1000

        // Get peaks
        this.peaks = this.sound.getPeaks(this.precision)

        // Create a new point for each peak
        for (let i in this.peaks) {
            if (this.peaks.hasOwnProperty(i)) {
                let x = this.peaks[i] * this.waveWidth
                x = i % 2 === 0 ? x : -x
                let y = i / this.peaks.length * p5.height * this.waveSpeed
                this.points.push(new Point(x, y))
            }
        }
    }

    onResize (p5) {}

    draw () {}

    play () {
        if (this.active && !this.isPlaying) {
            this.sound.play()
            this.sound.setVolume(1)
            this.isPlaying = true
        }
    }

    pause () {
        if (this.isPlaying) {
            this.sound.pause()
            this.sound.setVolume(0)
            this.isPlaying = false
        }
    }

    jump (percentage) {
        if (this.sound.output && this.sound.isPlaying()) {
            if (Utils.isMobile()) {
                this.isJumping = true
                window.clearTimeout(this.timeout)
                this.timeout = window.setTimeout(() => {
                    const seconds = this.duration * (percentage / 100)
                    const secondsMax = Math.min(Math.max(seconds, 0.1), this.duration - 0.1)
                    try {
                        this.sound.jump(this.precisionRound(secondsMax, 1))

                        window.setTimeout(() => {
                            this.isJumping = false
                        }, this.delay / 10)
                    } catch (e) {
                        console.error(e)
                    }
                }, this.delay)
            } else {
                this.isJumping = true
                const seconds = this.duration * (percentage / 100)
                const secondsMax = Math.min(Math.max(seconds, 0.1), this.duration - 0.1)
                try {
                    this.sound.jump(this.precisionRound(secondsMax, 1))
                    this.isJumping = false
                } catch (e) {
                    console.error(e)
                }
            }
        }
    }

    precisionRound (number, precision) {
        let factor = Math.pow(10, precision)
        return Math.round(number * factor) / factor
    }

    setVolume (volume) {
        if (this.sound) {
            this.volume = volume
            this.sound.setVolume(volume)
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/waveform/ASoundObject.js